import { render, staticRenderFns } from "./registrations-change-status.vue?vue&type=template&id=9e301230"
import script from "./registrations-change-status.vue?vue&type=script&lang=js"
export * from "./registrations-change-status.vue?vue&type=script&lang=js"
import style0 from "./registrations-change-status.vue?vue&type=style&index=0&id=9e301230&prod&scope=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports